module.exports = __webpack_public_path__ + "static/media/circle-view-off.84880f7c.svg";